import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const CustomerInfoSection = "/reports/omi/customer-info";

export const CustomerInfoListPath = CustomerInfoSection;

export enum CustomerInfoListUrlFiltersEnum {
  joinedFrom = "joinedFrom",
  joinedTo = "joinedTo",
  query = "query"
}
export type CustomerInfoListUrlFilters = Filters<
  CustomerInfoListUrlFiltersEnum
>;

export type CustomerInfoListUrlDialog = "remove" | "download" | TabActionDialog;
export type CustomerInfoUrlQueryParams = ActiveTab &
  CustomerInfoListUrlFilters &
  BulkAction &
  Dialog<CustomerInfoListUrlDialog> &
  Pagination &
  SingleAction;

export const CustomerInfoListUrl = (params?: CustomerInfoUrlQueryParams) =>
  CustomerInfoListPath + "?" + stringifyQs(params);
